import React from "react";
import { useTranslation } from "react-i18next";
import { isArray, isEmptyString } from "utils/types/typeguards";

type Props = {
	productTextId: string
}

function SingleProductPageUsage({
	productTextId
}: Props) {

	const { t } = useTranslation();

	const title = t([ `products.${ productTextId }.usage.title`, "" ]);
	const elements = t([ `products.${ productTextId }.usage.elements`, "" ], { returnObjects: true }) as string[] | string;

	return (
		<>
			{
				!(isEmptyString(title) && isEmptyString(elements) && elements.length === 0) &&
                <div className="container">
                    <div className="mt-14 flex flex-col gap-4">
						{
							!isEmptyString(title) &&
                            <h2 className="text-black font-medium">
								{ title }
                            </h2>
						}
						{
							(isArray(elements) && elements.length !== 0) &&
                            <ul>
								{
									elements.map((element, index) =>
										<li key={ index } className="flex mb-2 items-center">

											<div className="bg-sky-600 aspect-square h-10 flex justify-center items-center text-white rounded-full z-[1]">
												{ index + 1 }
											</div>
											<div className="bg-sky-400 text-white ml-[-20px] z-[0] pl-7 pr-5 pb-2 pt-2 flex items-center rounded-lg">
												 { element }
											</div>
										</li>
									)
								}
                            </ul>
						}
                    </div>
                </div>
			}
		</>
	);
}

export default SingleProductPageUsage;